module.exports = __webpack_public_path__ + "img/fc3.2e47fb22.png";